export const welcome = 
{
  "label": "Benvenuto",
  "labelDisable": false,
  "children": [
    {
      "name": "Per compilare il questionario",
      "to": "/app/info/azienda-per-iniziare",
      "exact": true,
      "active": true
    },
    {
      "name": "Presentazione",
      "to": "/app/welcome/presentazione",
      "exact": true,
      "active": true
    }
  ]
}
